import { ISettings, SearchOptions } from '../../types'
import {
    Action,
    AppAction,
    ChatAction,
    EventAction,
    EventType,
    ListAction,
    ListType,
    MessageAction,
    RoomAction,
    SearchAction,
    SettingsAction,
    UserAction,
} from '../constants/enums'

/** register a callback to receive messages from the worker */
export const workerOnMessage = (callback: (x: MessageEvent<any>) => void) => {
    if (typeof window === 'undefined') return
    window.__MFC_FCS_WORKER__?.addEventListener('message', callback)
    return () => {
        window.__MFC_FCS_WORKER__?.removeEventListener('message', callback)
    }
}

/** send message to the worker */
export const workerSendMessage = (
    type: EventType,
    action?: EventAction,
    data?: any,
) => {
    if (typeof window === 'undefined') return
    window.__MFC_FCS_WORKER__?.postMessage({ type, action, data })
}

/** send actions to the worker */
const workerAction = (action: EventAction, type: Action, payload?: any) =>
    workerSendMessage(EventType.ACTIONS, action, { type, payload })

export const appAction = (type: AppAction, payload: any) =>
    workerAction(EventAction.APP, type, payload)

export const messageAction = (type: MessageAction, payload?: any) =>
    workerAction(EventAction.MESSAGE, type, payload)

export const roomAction = (type: RoomAction, payload: any) =>
    workerAction(EventAction.ROOM, type, payload)

export const searchAction = (searchOptions: SearchOptions) => {
    workerAction(EventAction.SEARCH, SearchAction.SEARCH, searchOptions)
}

export const searchListAction = (payload: {
    list?: ListType
    fields?: object
    query: string
}) => workerAction(EventAction.SEARCH, SearchAction.SEARCH_LIST, payload)

export const updateSettingsAction = (settings: Array<ISettings>) =>
    workerAction(EventAction.UPDATE_SETTINGS, SettingsAction.UPDATE, settings)

export const userAction = (type: UserAction, payload?: any) =>
    workerAction(EventAction.USERS, type, payload)

export const listAction = (type: ListAction, payload: any) =>
    workerAction(EventAction.LISTS, type, payload)

export const workerResetLists = () =>
    workerAction(EventAction.LISTS, ListAction.RESET)

export const workerArchive = (payload?) =>
    workerAction(EventAction.ARCHIVE, ChatAction.ARCHIVE, payload)
